module.exports = __webpack_public_path__ + "static/media/flagged.24d40175.svg";